/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Access_Reason_No_Tool_AccessInputs */



/**
* | output |
* | --- |
* | "no tool access. An admin of \"{name}\" can grant it." |
*
* @param {Agent_Access_Reason_No_Tool_AccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_reason_no_tool_access = /** @type {((inputs: Agent_Access_Reason_No_Tool_AccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Reason_No_Tool_AccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Kein Werkzeugzugriff. Ein Admin von „${i?.name}“ kann ihn erteilen.`)
	return /** @type {LocalizedString} */ (`no tool access. An admin of "${i?.name}" can grant it.`)
});